import { GpsPoint } from '../telemetry/processed/GpsPoint'
import { LapBounds } from '../lap/LapBounds'
import { segmentIntersectionFraction } from '../../utils/geometryUtils'

export interface FinishLinePoint {
  latitude: number
  longitude: number
}

export interface FinishLineCrossing {
  segmentIndex: number
  fraction: number
  time: Date
}

/**
 * Every place the GPS track crosses the finish line, with the crossing time
 * interpolated between the two samples either side of the line.
 */
export function findFinishLineCrossings(
  gpsPoints: GpsPoint[],
  finishLine: FinishLinePoint[]
): FinishLineCrossing[] {
  const [lineStart, lineEnd] = finishLine
  const crossings: FinishLineCrossing[] = []
  for (let i = 0; i < gpsPoints.length - 1; i++) {
    const before = gpsPoints[i]
    const after = gpsPoints[i + 1]
    const fraction = segmentIntersectionFraction(
      before.latitude,
      before.longitude,
      after.latitude,
      after.longitude,
      lineStart.latitude,
      lineStart.longitude,
      lineEnd.latitude,
      lineEnd.longitude
    )
    if (fraction === null) continue
    const beforeMs = before.timestamp.getTime()
    const afterMs = after.timestamp.getTime()
    crossings.push({
      segmentIndex: i,
      fraction,
      time: new Date(beforeMs + fraction * (afterMs - beforeMs)),
    })
  }
  return crossings
}

export function lapBoundsBetween(
  crossings: Array<{ time: Date }>
): LapBounds[] {
  const bounds: LapBounds[] = []
  for (let i = 1; i < crossings.length; i++) {
    bounds.push({
      startTime: crossings[i - 1].time,
      finishTime: crossings[i].time,
      startDistanceMeters: 0,
      finishDistanceMeters: 0,
    })
  }
  return bounds
}
